export default {
	unexpected: 'Neočekávaná chyba',
	accessDenied: 'Nemáte oprávnení',
	BE: 'Chyba na REST rozhraní',
	auth: 'Uživatel není přihlášen',
	forbidden: 'Uživatel nemá oprávnění vykonat danou akci',
	notAllowed: 'HTTP metoda není podporována',
	unsupported: 'Zvolená hodnota v hlavičce Content-type není podporována',
	serverError: 'Na straně serveru došlo k nečekané chybě',
	notFound: 'Stránka nebyla nalezena',
	timeout: 'Request timeout',
	validationError: 'Došlo k validační chybě nebo argument metody není správný',
	noResults: 'Nebyl nalezen žádný záznam.',
};
